/**
 * Отправляет событие в виджет UX Feedback (`window.UXS`, грузится через GTM).
 * Если виджет не загружен (SSR, отключённый GTM, блокировщики) — молча выходит.
 */
export const sendUXSEvent = (name: string, attributes?: Record<string, string>) => {
  if (typeof window === 'undefined' || !window.UXS) {
    return;
  }

  if (attributes) {
    window.UXS.sendEvent(name, attributes);
  } else {
    window.UXS.sendEvent(name);
  }
};
